export default "__VITE_ASSET__DaSagtCX__"